export enum CommunityFormType {
  SUBSCRIPTION_CANCEL = 'subscriptionCancelFormId',
}

export class GetCommunityFormDto {
  type: CommunityFormType;
  communityId: string;
}
